class SalesforceUser extends React.PureComponent {
  render() {
    const { salesforceUser } = this.props;

    return <p>{salesforceUser.name || salesforceUser.id}</p>;
  }
}

SalesforceUser.defaultProps = {
  salesforceUser: {
    id: '—',
    name: null,
  },
};

SalesforceUser.propTypes = {
  salesforceUser: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }).isRequired,
};

export default SalesforceUser;
